<template>
    <div class="text-center">
      <!-- <v-btn
        color="orange-darken-2"
        @click="snackbar = true"
      >
        Open Snackbar
      </v-btn> -->
  
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        location="top right"
        color="secondary"
        rounded="lg"
        elevation="6"
      >
        <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
        {{ message }}

        <template v-slot:actions>
          <v-btn
            color="primary"
            variant="text"
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </template>
  <script>
    export default {
        name: "SnackBar",
        props: ['toggleSnackbar','responseMessage'],
      data() {
            return {
                snackbar: this.toggleSnackbar,
                message: this.responseMessage,
                timeout: 2000,
            };
        },
      watch: {
            toggleSnackbar(val) {
                this.snackbar = val;
                setTimeout(() => {
                    this.snackbar = false;
                }, 2000);
            },
            responseMessage(val) {
                this.message = val;
            },
        },
    }
  </script>